'use client';

export { default } from './Slide';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Slide/index.js
// module id = 453
// module chunks = 22